export class PusherConfigModel {
  authApiUrl: string;
  applicationId: string;
  cluster: string;
  authEndpoint: string;
}
